import { useEffect } from "react"

function DAppsView() {
    useEffect(() => {
      document.title = "DApps - KAXAA Wallet"
    }, [])

    const dapps = [
      {
        name: "Uniswap",
        description: "Decentralized exchange protocol",
        category: "DeFi",
        url: "https://uniswap.org",
        featured: true,
      },
      {
        name: "Compound",
        description: "Lending and borrowing protocol",
        category: "DeFi",
        url: "https://compound.finance",
        featured: true,
      },
      {
        name: "OpenSea",
        description: "NFT marketplace",
        category: "NFT",
        url: "https://opensea.io",
        featured: false,
      },
    ]
  
    return (
      <div className="dapps-view">
        <div className="dapps-card">
          <h2>Decentralized Applications</h2>
  
          <div className="dapps-list">
            {dapps.map((dapp, index) => (
              <div key={index} className="dapp-item">
                <div className="dapp-info">
                  <div className="dapp-icon">{dapp.name[0]}</div>
                  <div className="dapp-details">
                    <div className="dapp-name">
                      {dapp.name}
                      {dapp.featured && <span className="featured-star"></span>}
                    </div>
                    <p className="dapp-description">{dapp.description}</p>
                    <span className="">{dapp.category}</span>
                  </div>
                </div>
                <button className="connect-button">🔗 Connect</button>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
  
  export default DAppsView
  